import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Checkbox from '@material-ui/core/Checkbox'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import HelperText from './HelperText'
import { getProps } from './utils'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
}))

const CheckboxField = (props) => {
  const {
    field: {
      name,
      value,
      onChange,
    },
    form: {
      setFieldValue,
    },
    disabled,
    error,
    touched,
    item,
  } = getProps(props)

  const classes = useStyles()
  const title = item.title || name

  return (
    <FormControl component="fieldset" className={ classes.root } disabled={ disabled }>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              name={ name }
              checked={ value ? true : false }
              onChange={ (e) => {
                setFieldValue(name, e.target.checked)
              }}
              value={ name }
            />
          }
          label={ title }
        />
      </FormGroup>
      {
        item.helperText && (
          <HelperText
            helperText={ item.helperText }
            touched={ touched }
          />
        )
      }
      {
        touched && error && (
          <HelperText
            helperText={ error }
            error
            touched={ touched }
          />
        )
      }
    </FormControl>
  )

}

export default CheckboxField